import {Component, effect, input, output, signal, Signal} from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

import { FormInputComponent } from '../../utils/form-input/form-input.component';
import {VehicleModel} from '../../../models/resources/vehicle.model';
import {LinkSelectComponent} from "../../utils/link-select/link-select.component";
import {EmployeeService} from "../../../services/resources/employee.service";
import {EmployeeModel} from "../../../models/resources/employee.model";
import {TextAreaInputComponent} from "../../utils/text-area-input/text-area-input.component";
import {LocationModel} from "../../../models/resources/location.model";
import {LocationService} from "../../../services/resources/location.service";
import { castVehicleTypeEnum, VehicleType} from "../../../enums/vehicle.type";
import {ReadOnlyInputComponent} from "../../utils/read-only-input/read-only-input.component";
import {CheckboxInputComponent} from "../../utils/checkbox-input/checkbox-input.component";

@Component({
  selector: 'app-vehicle-form',
  imports: [
    ReactiveFormsModule,
    FormInputComponent,
    TranslateModule,
    TextAreaInputComponent,
    LinkSelectComponent,
    ReadOnlyInputComponent,
    CheckboxInputComponent
  ],
  templateUrl: './vehicle-form.component.html',
  styleUrl: './vehicle-form.component.scss',
})
export class VehicleFormComponent {
formGroupOutput = output<FormGroup>();
formGroup: Signal<FormGroup>;
vehicle = input<VehicleModel>();

// vitabeneEmployee = input<EmployeeModel>();
selectedEmployee = signal<EmployeeModel | undefined>(undefined);
// location = input<LocationModel>();
selectedLocation = signal<LocationModel | undefined>(undefined);


constructor(
  private formBuilder: FormBuilder,
  public employeeService: EmployeeService,
  public locationService: LocationService
) {
  this.formGroup = signal(this.formBuilder.group({
    type: [VehicleType.PKW],
    active: [true, []],
    name: [null, [Validators.required]],
    description: [null],
    capacity: [null, [Validators.required, Validators.min(3), Validators.pattern(/^\d+$/)]],
    vitabeneEmployee: [null, []],
    location: [null, []],
    employeeStartTime:  [null, []],
    employeeEndTime:  [null, []],
    employeeBreakDuration:  [null, []]
    }))

  this.formGroup()
    .get('vitabeneEmployee')
    ?.valueChanges.subscribe({
    next: (value) => {
      this.selectedEmployee.set(value);
    },
  });

  this.formGroup()
    .get('location')
    ?.valueChanges.subscribe({
    next: (value) => {
      this.selectedLocation.set(value);
    },
  });
    effect(() => {
      if (this.vehicle())
        this.updateFormValues();
      });

    effect(() => {
      this.formGroupOutput.emit(this.formGroup());
      });
  }

  updateFormValues() {
    const currentModel = this.vehicle();

    if(currentModel) {
      this.formGroup().patchValue({
        type: currentModel.type,
        name: currentModel.name,
        description: currentModel?.description,
        capacity: currentModel.capacity,
        active: currentModel.active,
        vitabeneEmployee: currentModel?.vitabeneEmployee ?? null,
        location: currentModel?.location ?? null,
        employeeStartTime: currentModel.employeeStartTime?.substring (0,5) ?? null,
        employeeEndTime: currentModel.employeeEndTime?.substring (0,5) ?? null,
        employeeBreakDuration: currentModel?.employeeBreakDuration ?? null,
      });
    }
  }

  protected readonly castVehicleTypeEnum = castVehicleTypeEnum;
}
